<template>
  <div>
    <el-form
      class="query-form new-input-box"
      ref="refForm"
      :model="searchData"
      :size="size"
      :inline="inline"
      :label-width="labelWidth"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <el-form-item
        v-for="item in formInfo"
        :label="item.label"
        :key="item.prop"
        :prop="item.prop"
        class="form_item"
        :class="{
          'long-form': longTypeArr.includes(item.type),
          nobtm: removeBottom,
        }"
      >
        <!-- 自定义 -->
        <div v-if="item.slotLabel">
          <slot :name="item.slotLabel" :scope="item"></slot>
        </div>
        <div v-if="item.slot">
          <slot :name="item.slot" :scope="item"></slot>
        </div>
        <div v-if="item.slotError">
          <slot :name="item.slotError" :scope="item"></slot>
        </div>
        <!-- 输入框 -->
        <el-input
          v-if="item.type === 'Input'"
          v-model="searchData[item.prop]"
          :style="{ width: item.width || width }"
          :placeholder="item.placeholder"
        ></el-input>
        <!-- 双输入框 -->
        <template v-else-if="item.type === 'InputDouble'">
          <div :style="{ width: item.width || width }" class="input_flex">
            <el-input
              v-model="searchData[item.startKey]"
              class="input_item"
              :placeholder="item.startPlaceholder"
              style="width: 145px"
            ></el-input>
            <span
              style="margin: 0 8px; line-height: 32px"
              class="time-span-text"
              >至</span
            >
            <el-input
              v-model="searchData[item.endKey]"
              class="input_item"
              :placeholder="item.endPlaceholder"
              style="width: 145px"
            ></el-input>
          </div>
        </template>
        <!-- 下拉框 -->
        <el-select
          v-else-if="item.type === 'Select'"
          v-model="searchData[item.prop]"
          :disabled="item.disabled"
          :style="{ width: item.width || width }"
        >
          <el-option
            v-for="op in item.options"
            :label="op.label"
            :value="op.value"
            :key="op.value"
          ></el-option>
        </el-select>
        <!-- 单选 -->
        <el-radio-group
          v-else-if="item.type === 'Radio'"
          v-model="searchData[item.prop]"
          :style="{ width: item.width || width }"
        >
          <el-radio
            v-for="ra in item.options"
            :label="ra.value"
            :key="ra.value"
            :style="{ width: ra.width || 'auto' }"
            >{{ ra.label }}</el-radio
          >
        </el-radio-group>
        <!-- 单选按钮 -->
        <el-radio-group
          v-else-if="item.type === 'RadioButton'"
          v-model="searchData[item.prop]"
        >
          <el-radio-button
            v-for="ra in item.options"
            :label="ra.value"
            :key="ra.value"
            >{{ ra.label }}</el-radio-button
          >
        </el-radio-group>
        <!-- 复选框 -->
        <el-checkbox-group
          v-else-if="item.type === 'Checkbox'"
          v-model="searchData[item.prop]"
        >
          <el-checkbox v-if="item.all" label="不限" value=""></el-checkbox>
          <el-checkbox
            v-for="ch in item.options"
            :label="ch.value"
            :key="ch.value"
            >{{ ch.label }}</el-checkbox
          >
        </el-checkbox-group>
        <!-- 日期范围 -->
        <time-pick
          v-else-if="item.type === 'DateRange'"
          :type="item.dateType"
          :style="{ width: item.width || width }"
          :startTime="searchData[item.startKey]"
          :endTime="searchData[item.endKey]"
          :format="item.format"
          :defaultValueStart="item.defaultValueStart"
          :defaultValueEnd="item.defaultValueEnd"
          :defalutLimit="item.defalutLimit"
          @change="(time) => changeDate(time.startTime, time.endTime, item)"
        ></time-pick>
        <!-- 单选+自定义 -->
        <el-radio-group
          v-else-if="item.type === 'RadioCustom'"
          v-model="searchData[item.prop]"
        >
          <template v-for="ra in item.options">
            <el-radio :label="ra.value">
              {{ ra.label }}
            </el-radio>
            <template v-if="ra.custom">
              <el-input
                class="short-input"
                size="small"
                v-model="searchData[ra.startKey]"
                type="text"
                style="width: 120px"
                :disabled="searchData[item.prop] != ra.value"
              >
                <span slot="suffix">{{ ra.unit }}</span>
              </el-input>
              <span
                style="display: inline-block; margin: 0 5px; font-size: 14px"
                class="time-span-text"
                >至</span
              >
              <el-input
                class="short-input"
                size="small"
                v-model="searchData[ra.endKey]"
                type="number"
                style="width: 120px"
                :disabled="searchData[item.prop] != ra.value"
              >
                <span slot="suffix">{{ ra.unit }}</span>
              </el-input>
            </template>
          </template>
        </el-radio-group>
        <!-- 单选+自定义日期范围 -->
        <el-radio-group
          v-else-if="item.type === 'RadioCustomDate'"
          v-model="searchData[item.prop]"
        >
          <template v-for="ra in item.options">
            <el-radio :label="ra.value">
              {{ ra.label }}
            </el-radio>
            <template v-if="ra.custom">
              <el-input
                class="short-input"
                size="small"
                v-model="searchData[ra.startKey]"
                type="text"
                style="width: 120px"
                :disabled="searchData[item.prop] != ra.value"
              >
                <span slot="suffix">{{ ra.unit }}</span>
              </el-input>
              <span
                style="display: inline-block; margin: 0 5px; font-size: 14px"
                class="time-span-text"
                >至</span
              >
              <el-input
                class="short-input"
                size="small"
                v-model="searchData[ra.endKey]"
                type="number"
                style="width: 120px"
                :disabled="searchData[item.prop] != ra.value"
              >
                <span slot="suffix">{{ ra.unit }}</span>
              </el-input>
            </template>
          </template>
        </el-radio-group>
        <!-- 下拉框+自定义日期范围 -->
        <selectCustomDate
          v-else-if="item.type === 'SelectCustomDate'"
          :style="{ width: item.width || width }"
          :startTime.sync="searchData[item.startKey]"
          :endTime.sync="searchData[item.endKey]"
          :baseDate="item.baseDate"
          :ref="item.startKey"
          :type="item.timeType"
        >
        </selectCustomDate>
        <!-- 下拉框+自定义日期范围 -->
        <selectCustomDate
          v-else-if="item.type === 'SelectCustomDate2'"
          :style="{ width: item.width || width }"
          :startTime.sync="searchData[item.startKey]"
          :endTime.sync="searchData[item.endKey]"
          :baseDate="item.baseDate"
          :baseDateStart="item.baseDateStart"
          :baseDateEnd="item.baseDateEnd"
          :yesterday="item.yesterday"
          :baseType="item.baseType"
          :ref="item.startKey"
        >
        </selectCustomDate>
        <!-- 单选+选择商品 -->
        <!-- 选择地区 -->
        <!-- <el-radio-group
          v-else-if="item.type === 'City'"
          v-model="searchData[item.prop]"
        >
          <template v-for="ra in cityOptions">
            <el-radio :label="ra.value">
              {{ ra.label }}
            </el-radio>
          </template>
          <template>
            <dy-button
              @click="handeSelectCity"
              v-if="searchData[item.customKey]"
              v-show="searchData[item.prop] == 3"
              :disabled="searchData[item.prop] != 3"
              type="select"
              :styleTextObj="{'height': '30px', 'width': '145px', 'line-height': '30px', 'border': '0px'}"
            >
              已选<span>{{
                searchData[item.customKey].length
              }}</span
              >个
            </dy-button>
            <city-popover
              :value="cityVisible"
              :checkedList="searchData[item.customKey]"
              @confirm="(arr) => (searchData[item.customKey] = arr,cityVisible = false)"
              @close="cityVisible = false"
            ></city-popover>
          </template>
        </el-radio-group> -->
        <!-- 选择商品 -->
        <input-goods
          v-else-if="item.type === 'InputGoods'"
          :isNeedSku="item.isNeedSku ? item.isNeedSku : false"
          :style="{ width: item.width || width }"
          v-model="searchData[item.prop]"
          @changeSku="handleSkuChange"
        ></input-goods>
        <!-- 开关 -->
        <el-switch
          v-else-if="item.type === 'Switch'"
          v-model="searchData[item.prop]"
        ></el-switch>
      </el-form-item>
      <!-- 添加特殊时间 -->
      <template
        style="display: inline-block; margin-top: -10px; width: 350px"
        v-if="showTrue == '1'"
      >
        <span v-if="show == '1'">
          <br />
        </span>
        <span style="margin-top: 10px; color: #666; margin-left: 30px"
          >下单时间:</span
        >
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="analyzeForm.startTime"
          type="datetime"
          placeholder="选择日期时间"
          size="small"
          style="margin-left: 10px; width: 145px"
        >
        </el-date-picker>
        <span style="margin-left: 8px; margin-right: 8px" class="time-span-text"
          >至</span
        >
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="analyzeForm.endTime"
          type="datetime"
          placeholder="选择日期时间"
          size="small"
          style="width: 145px"
        ></el-date-picker>
      </template>
      <!-- end -->
      <!-- 按钮 -->
      <div
        class="button-box"
        :style="{
          left: btnLeft ? btnLeft : '',
          bottom: btnBottom ? btnBottom : '',
          top: btnTop ? btnTop : '',
        }"
        v-if="customBtnList.length > 0"
      >
        <template>
          <div v-for="(item, index) in customBtnList" :key="index">
            <div>
              <dt-button
                :type="item.type"
                :size="item.size || size"
                @click="handleBtn(item)"
                >{{ item.label }}</dt-button
              >
            </div>
          </div>
        </template>
      </div>
      <template v-else>
        <el-form-item label=" ">
          <dy-button type="break" @click="handleSearch">查询</dy-button>
          <dy-button type="glay" v-if="!noReset" @click="handleReset"
            >重置</dy-button
          >
        </el-form-item>
      </template>

      <!-- 额外的按钮 -->
      <slot name="buttonOut"></slot>
    </el-form>
  </div>
</template>

<script>
// 搬运云舟组件
/** formInfo
 * prop  表单域 model 字段
 * label 标签文本
 * placeholder 占位文本
 * disabled 禁用
 * type  类型 Input Select Radio RadioButton Checkbox Switch Time Date
 * width 宽度
 * value 默认值
 * size  尺寸
 * slot  插槽名称
 * slotLabel 表单标签插槽名称（不要和slot名称重复）
 * slotError 表单校验信息插槽名称，参数为 { error }
 * change  选中值发生变化时触发
 *
 * 部分类型独有配置
 * ( Input )
 * maxlength 最大输入长度
 * show-word-limit 是否显示输入字数统计
 * ( Select Radio RadioButton )
 * options 选项组
 *
 * ( InputDouble )
 * startKey 起始key
 * endKey   结尾key
 * startValue 起始默认值
 * endValue   结尾默认值
 * startPlaceholder 起始提示文本
 * endPlaceholder   结尾提示文本
 *
 * ( DateRange ) 详情参考timePick组件说明
 * startKey: 开始时间绑定的key
 * endKey: 结束时间绑定的key
 * dateType: 时间组件的类型 默认 date
 * format 时间格式 datetime默认为"yyyy-MM-dd HH:mm:ss" date默认为"yyyy-MM-dd"
 * defaultValueStart  开始时间的default-value;  defaultValueEnd 结束时间的default-value
 * lastDay: 默认近几天
 *
 * （SelectCustomDate）下拉框+自定义时间
 * startKey: 开始时间绑定的key
 * endKey: 结束时间绑定的key
 *
 * 说明： 因目前场景有限，暂固定选项为 '近7天''近15天''近30天''自定义',固定选中'近7天' 后续有需要再自行添加参数
 *
 * ( RadioCustom )独占一行组件
 * prop  表单域 model 字段
 * label 标签文本
 * value 默认值
 * options 选项组 [item]
 * item:{
 *   label:  文本
 *   value:  对应值
 *   custom: 是否添加自定义框 Boolean
 *   startKey: 自定义框起始字段  custom为true必传
 *   endKey:   自定义框结尾字段  custom为true必传
 *   unit: 自定义框单位
 *   startValue:自定义框起始默认值
 *   endValue:  自定义框结尾默认值
 *
 * ( City ) 独占一行组件
 * prop  表单域 model 字段
 * label 标签文本
 * value 默认值
 * customKey 自定义 城市数组key
 * customValue 自定义 城市默认数组 不传为[]
 *
 * }
 */
import timePick from "./timePick.vue";
import selectCustomDate from "./selectCustomDate.vue";
// import cityPopover from "@/components/Dialog/city.vue";
import inputGoods from "./inputGoods.vue";

export default {
  components: {
    timePick,
    // cityPopover,
    inputGoods,
    selectCustomDate,
  },
  props: {
    show: null,
    showTrue: null,
    labelWidth: {
      type: String,
      default: "124px",
    },
    width: {
      type: String,
      default: "280px",
    },
    size: {
      type: String,
      default: "small",
    },
    inline: {
      type: Boolean,
      default: true,
    },
    formInfo: {
      type: Array,
      default: () => [],
    },
    // 自定义按钮列表
    customBtnList: {
      type: Array,
      default: () => [],
    },
    // 是否关闭重置按钮
    noReset: {
      type: Boolean,
      default: false,
    },
    // 是否立即触发
    immediately: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //查询区位置
    btnLeft: {
      type: String,
      default: "1350px",
    },
    btnTop: {
      type: String,
      default: null,
    },
    btnBottom: {
      type: String,
      default: null,
    },
    // 移除底部18px外边距 为不影响原有效果 默认为false
    removeBottom: {
      type: Boolean,
      default: false,
    },
    // 重置按钮自定义事件
    emitReset: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    //处理客户分析节点--此逻辑后续需优化
    if (this.showTrue == 1) {
      sessionStorage.setItem("isTime", this.formData.tradeCreateStartTime);
      sessionStorage.setItem("isTime1", this.formData.tradeCreateEndTime);
      this.analyzeForm.startTime = this.formData.tradeCreateStartTime;
      this.analyzeForm.endTime = this.formData.tradeCreateEndTime;
    }
    //end
    let obj = this.getInitForm();
    Object.keys(obj).forEach((item) => {
      this.$set(this.searchData, item, obj[item]);
    });
    if (this.immediately) {
      this.handleSearch();
    }
  },
  watch: {},
  data() {
    return {
      isSku: false,
      value1: "",
      analyzeForm: {
        startTime: "",
        endTime: "",
      },
      searchData: {},
      longTypeArr: ["RadioCustom", "City"],
      cityOptions: [
        { label: "不限", value: "" },
        { label: "江浙沪", value: 1 },
        { label: "偏远地区", value: 2 },
        { label: "自定义", value: 3 },
      ],
      // 选择地区
      cityVisible: false,
      // 选择商品
      goodsVisible: false,
    };
  },
  methods: {
    handleSkuChange(val) {
      this.isSku = val;
    },
    handleSearch() {
      this.$emit("update:formData", { ...this.formData, ...this.searchData });
      let params = { ...this.searchData };
      if (this.isSku) {
        params.isSku = this.isSku;
      }
      this.$emit("search", params);
      //处理客户分析节点--此逻辑后续需优化
      if (this.showTrue == 1) {
        this.$emit("customer", this.analyzeForm);
        this.$emit("customer1", this.analyzeForm);
        this.$emit("customer2", this.analyzeForm);
      }
      //end
    },
    handleReset() {
      let obj = this.getInitForm();
      Object.keys(obj).forEach((item) => {
        this.searchData[item] = obj[item];
      });
      //end
      setTimeout(() => {
        this.$emit("update:formData", { ...this.formData, ...this.searchData });
        // 兼容使用插槽,表单无法重置问题
        if (this.emitReset) {
          this.$emit("reset");
        } else {
          this.$emit("search", this.searchData);
        }
      }, 500);
      //处理客户分析节点--此逻辑后续需优化
      if (this.showTrue == 1) {
        let strong = sessionStorage.getItem("isTime");
        let strong1 = sessionStorage.getItem("isTime1");
        this.analyzeForm.startTime = strong;
        this.analyzeForm.endTime = strong1;
        this.$emit("customer", this.analyzeForm);
        this.$emit("customer1", this.analyzeForm);
        this.$emit("customer2", this.analyzeForm);
      }
    },
    handleBtn(item) {
      this.$emit(item.handle, this.searchData);
    },
    setFormData(data) {
      // 设置表单数据，用于初始化表单
      this.searchData = { ...this.searchData, ...data };
    },
    changeDate(start, end, item) {
      console.log(start, end, item);
      if (new Date(start) > new Date(end) && end) {
        this.$message.warning("开始时间不能大于结束时间");
        return;
      }
      this.searchData[item.startKey] = start;
      this.searchData[item.endKey] = end;
    },
    // 判断是不是undefined
    isUndefined(val) {
      if (val == undefined) return null;
      else return val;
    },

    // 获取初始化对象
    getInitForm() {
      // this.$refs.refForm.resetFields();
      let formObj = {};
      this.formInfo
        .filter((item) => !item.slot)
        .map((item) => {
          if (item.type == "DateRange") {
            if (!!item.lastDay || item.lastDay === 0) {
              formObj[item.startKey] = this.getLastTime(item.lastDay);
              if (item.noEndTime) {
                formObj[item.endKey] = null;
              } else {
                formObj[item.endKey] = this.getLastTime(0);
              }
            } else {
              formObj[item.startKey] = this.isUndefined(item.startTime);
              formObj[item.endKey] = this.isUndefined(item.endTime);
            }
          } else if (item.type == "SelectCustomDate") {
            console.log(this.$refs[item.startKey]);
            this.$refs[item.startKey][0].handleChange(7);
            // formObj[item.startKey] = this.getLastTime(7);
            // formObj[item.endKey] = this.getLastTime(0);
          } else if (item.type == "SelectCustomDate2") {
            console.log(this.$refs[item.startKey]);
            this.$refs[item.startKey][0].handleChange(item.baseType);
          } else if (item.type == "InputDouble") {
            formObj[item.startKey] = this.isUndefined(item.startValue);
            formObj[item.endKey] = this.isUndefined(item.endValue);
          } else if (item.type == "RadioCustom") {
            formObj[item.prop] = this.isUndefined(item.value);
            item.options &&
              item.options.forEach((ra) => {
                if (ra.custom) {
                  formObj[ra.startKey] = this.isUndefined(ra.startValue);
                  formObj[ra.endKey] = this.isUndefined(ra.endValue);
                }
              });
          } else if (item.type == "City") {
            formObj[item.prop] = this.isUndefined(item.value);
            formObj[item.customKey] = item.customValue || [];
          } else {
            formObj[item.prop] = this.isUndefined(item.value);
          }
        });
      return { ...formObj };
    },
    // 获取最近 last 天时间 格式 yyyy-mm-dd
    getLastTime(last) {
      let count = Number(last);
      const date = new Date(Date.now() - count * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      console.log("last", date, `${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    },
    // 选择地区弹窗
    handeSelectCity(item) {
      this.cityVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.button-box {
  position: absolute;
  bottom: 16px;
}
.query-form {
  position: relative;
}

// /deep/ .query-form.el-form--inline {
//   // 普通
//   font-size: 14px;
//   .el-form-item {
//     margin-right: 30px;
//     margin-bottom: 16px;
//     .el-form-item__label {
//       width: 100px;
//       padding: 0;
//       color: #666;
//     }

//     .el-form-item__content {
//       // width: 320px;
//       height: 32px;
//       .el-input__inner {
//         height: 32px;
//         line-height: 32px;
//       }
//       .input_flex {
//         display: flex;
//         .input_item {
//           flex: 1;
//         }
//       }
//     }
//     .el-form-item__content > :first-child {
//       width: 100%;
//     }
//   }
//   // 独占一行
//   .long-form.el-form-item {
//     display: flex;
//     width: 100%;
//     align-items: flex-start;
//     .el-form-item__label {
//       width: 100px;
//       padding: 0;
//     }
//     .el-form-item__content {
//       flex: 1;
//       // width: auto;
//       .el-input__suffix {
//         line-height: 32px;
//       }
//     }
//     .el-form-item__content > :first-child {
//       width: 100%;
//     }
//   }
//   // 两个输入框
//   .two-input.el-form-item {
//     margin-right: 30px;
//     margin-bottom: 16px;
//     .el-form-item__label {
//       width: 100px;
//       padding: 0;
//     }

//     .el-form-item__content {
//       width: 320px;
//     }
//     .el-form-item__content > :first-child {
//       width: 100%;
//       display: flex;
//       .short-input {
//         flex: 1;
//       }
//       .center-text {
//         margin: 0 7px;
//       }
//     }
//   }
// }
// :deep(.el-input__inner) {
//   &::placeholder {
//     color: #ccc;
//   }
// }
.nobtm {
  margin-bottom: 0;
}
</style>
